class TamaroDrinks
{
   constructor()
   {
      this.init();
   }

   init = () =>
   {
      this.setListeners();
   }

   setListeners = () =>
   {

      const fadeIn = document.querySelectorAll('.animate');

      if (fadeIn.length)
      {
         [...fadeIn].forEach(element =>
         {
            ScrollTrigger.create({
               trigger: element,
               start: 'top 90%',
               onEnter: () =>
               {
                  element.classList.add('animating');
               },
            });
         });
      }

      const megaMenuContents = document.querySelectorAll('.mega-menu__content');
      if( megaMenuContents.length > 0 )
      {
         [...megaMenuContents].forEach( (content, index) => {
            const productLinks = content.querySelectorAll('a[data-menu-product-id]');
            if( productLinks.length > 0 )
            {
               const imagesContainer = content.querySelector(`#mega-menu__product-images-${index + 1}`);
               const allImages = imagesContainer.querySelectorAll('img');
               [...productLinks].forEach( (link, index) => {
                  link.addEventListener('mouseover', () =>
                  {
                     [...allImages].forEach(img => {
                        img.style.display = 'none';
                     });
                     const productId = link.dataset.menuProductId;
                     const selectedImage = imagesContainer.querySelector(`img.product-image-thumb-${productId}`);
                     if( selectedImage )
                     {
                        selectedImage.style.display = 'block';
                     }
                  });
                  link.addEventListener('mouseleave', () =>
                  {
                     [...allImages].forEach(img => {
                        img.style.display = 'none';
                     });
                  });
               });
            }
         });
      }

   }
}

window.addEventListener('DOMContentLoaded', function ()
{
   new TamaroDrinks();
}, false);